import React, { Fragment, useRef, useState, useEffect } from "react";
import HoverIconButton from "components/HoverIconButton";
import { FieldArray, useFormikContext } from "formik";
import { getFieldPath } from "utils/form";
import get from "lodash/get";
import CheckoutShippingRatePicker from "components/CheckoutShippingRatePicker";
import classnames from "classnames";
import SlimCTA from "components/SlimCTA";
import { BUTTON_CLASS_CONTEXT } from "utils/constants/ui";
import { getSelectShippingOptionScaffold } from "utils/shippingRate";
import { CHECKOUT_SHIPPING_OPTION_MAX } from "utils/constants/shippingRate";

const NO_MODELS_SUBHEADER = "Add a shipping option to this checkout.";

const CheckoutShippingRatesPickers = ({
  rootPath,
  name,
  editMode,
  showEmptyCopy
}) => {
  const { values } = useFormikContext();
  const fieldName = getFieldPath(rootPath, name);
  const [showOnMountKey, setShowOnMountKey] = useState();
  const firstNameRef = useRef(null);
  useEffect(() => {
    firstNameRef.current && firstNameRef.current.focus();
  }, []);

  const models = get(values, fieldName) || [];
  const modelsCount = models.length;
  const hasModels = modelsCount > 0;
  const limitReached = modelsCount >= CHECKOUT_SHIPPING_OPTION_MAX;

  return (
    <Fragment>
      <FieldArray
        name={fieldName}
        render={(arrayHelpers) => {
          let content;

          const addShippingOption = () => {
            const shippingOption = getSelectShippingOptionScaffold();

            setShowOnMountKey(shippingOption.key);
            arrayHelpers.push(shippingOption);
          };

          if (hasModels) {
            content = (
              <ul className="list ma0 pa0 w-100 h-100">
                {models.map((model, modelIx) => {
                  const modelName = `${fieldName}[${modelIx}]`;

                  const pickerProps = {
                    name: modelName,
                    modelIx: modelIx,
                    arrayHelpers: arrayHelpers,
                    editMode,
                    showOnMount: showOnMountKey && showOnMountKey === model.key
                  };
                  if (!modelIx) {
                    pickerProps.innerNameRef = firstNameRef;
                  }

                  /**
                   * In create mode we append a placeholder key to the new models
                   * In edit mode we use the chosen taxRate
                   */
                  const keyName = model.key || model.shipping_rate;
                  return (
                    <div
                      key={keyName}
                      className={classnames("w-100", {
                        pt3: modelIx
                      })}
                    >
                      <CheckoutShippingRatePicker {...pickerProps} />
                    </div>
                  );
                })}
                {editMode ? (
                  <div
                    key="add-item"
                    className="flex flex-row justify-start pt3"
                  >
                    <div className="flex flex-row w-100 justify-end items-center">
                      <div className="fw5 f6 pr2">
                        {!limitReached
                          ? `Add shipping option`
                          : `Max ${CHECKOUT_SHIPPING_OPTION_MAX} shipping options`}
                      </div>
                      {!limitReached ? (
                        <HoverIconButton
                          type="add"
                          tooltip="Add"
                          onClick={addShippingOption}
                        />
                      ) : null}
                    </div>
                  </div>
                ) : null}
              </ul>
            );
          } else {
            let ctaProps;
            if (editMode) {
              ctaProps = {
                customClasses: {
                  container:
                    "w-100 flex flex-column flex-row-ns justify-between items-start items-center-ns bg-white",
                  subheader: "f6 lh-copy"
                },
                subheader: showEmptyCopy ? NO_MODELS_SUBHEADER : "",
                actions: [
                  {
                    copy: "Add",
                    classes: {
                      contextClass: BUTTON_CLASS_CONTEXT.SECONDARY
                    },
                    onClick: addShippingOption
                  }
                ]
              };
            } else {
              ctaProps = {
                subheader: "No shipping rates added."
              };
            }

            content = <SlimCTA {...ctaProps} />;
          }

          return content;
        }}
      />
    </Fragment>
  );
};

export default CheckoutShippingRatesPickers;
